import { DrumMap } from '@ezchops/drums';
import { Arrays, Numeric } from '@ezchops/helpers';
import { isMusicSheet, isMusicSheetSegment, isTimeSignature } from '@ezchops/musicsheet';
import { isTrackSet } from '../track';
import { isTrack } from '../track/Track';
var partition = Arrays.partition;
export function isExercise(x) {
    return x != null && typeof x.id == 'string' &&
        (typeof x.name == 'string') &&
        (x.description == null || typeof x.description == 'string') &&
        (x.metronomeSheet == null || isMusicSheet(x.metronomeSheet)) &&
        (Array.isArray(x.pads) && x.pads.every((n) => n in DrumMap)) &&
        (typeof x.defaultTempo == 'number');
}
export function isTrackSetExercise(x) {
    const ix = isExercise(x);
    const hasPeriodSegment = 'periodSegment' in x && isMusicSheetSegment(x.periodSegment);
    const hasTrackSet = 'track' in x && isTrackSet(x.track);
    return ix &&
        hasPeriodSegment &&
        hasTrackSet;
}
export function isMetronomeExercise(x) {
    return isExercise(x) &&
        ('signature' in x && isTimeSignature(x.signature));
}
export function isSheetExercise(x) {
    return isExercise(x) &&
        ('sheet' in x && isMusicSheet(x.sheet));
}
export function isSequencerExercise(x) {
    return isSheetExercise(x) &&
        ('track' in x && isTrack(x.track));
}
export function tickNoteToGrid(tickNote) {
    const factors = Numeric.primeFactors(tickNote);
    const [regular, irregular] = partition(factors, (([p,]) => p == 2));
    if (regular.length == 0) {
        throw new Error(`No regular division in ${tickNote}`);
    }
    if (irregular.length > 1) {
        throw new Error(`Too many irregulars in ${tickNote}: ${irregular}`);
    }
    const notImplemented = irregular.filter(([p, n]) => (p != 3 && p != 5 && p != 7) || n > 1);
    if (notImplemented.length > 0) {
        throw new Error(`Not implemented divisions in ${tickNote}: ${notImplemented}`);
    }
    const resolution = 1 << regular[0][1];
    const tuplets = irregular.map(([p,]) => p);
    return { resolution, tuplets };
}
export function gridToTickNote({ resolution, tuplets }) {
    return resolution * (tuplets ?? []).reduce((acc, p) => acc * p, 1);
}
//# sourceMappingURL=Exercise.js.map